
/* -------------------------------------------------------------------------------- *\
|                               getversion
\* -------------------------------------------------------------------------------- */
export const getversion = (): string =>
{
    return "centralizer @mclloyd 2025 - version 2.5.5";
}
